import Link from '@eliadmin/core/src/components/link';

import { Button } from '@eliadmin/core/src/components/ui/button';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export const CallToAction = ({ colSpan }: { colSpan: number }) => {
  return (
    <div
      className={cn(
        `col-span-1 sm:col-span-${colSpan} lg:col-span-${colSpan}`,
        'flex min-h-[414px] w-full flex-col items-start justify-center gap-6 rounded-[24px] bg-primary px-8 sm:min-h-[460px] md:rounded-[48px] md:px-10 xl:px-12',
      )}
    >
      <h3 className="text-3xl font-bold text-white lg:text-4xl">
        Plánujete projekt?<br></br>
        Stretneme sa a poradíme Vám.
      </h3>
      <p className="text-sm text-white sm:text-base md:text-lg lg:text-xl xl:text-2xl">#zadarmo</p>
      <Button asChild variant={'secondary'}>
        <Link prefetch={false} href={'/kontakt'}>
          Kontaktovať
        </Link>
      </Button>
    </div>
  );
};
